import { ListItemText, MenuItem, TextField, type SelectChangeEvent } from "~/common/mui";
import Checkbox from "~/common/components/Checkbox";

interface DropdownWithMultiSelectProps {
  items: MultiselectAccountValue[];
  value: string[]; //ids or codes, values
  onChange: (e: SelectChangeEvent<string[]>) => void;
  onBlur?: () => void;
  label?: string;
  error?: boolean;
  helperLabel?: string;
  className?: string;
  name?: string;
}

export type MultiselectAccountValue = {
  name: string;
  value: string;
  isChecked: boolean;
};

const DropdownWithMultiSelect = ({ items, value, onChange, ...rest }: DropdownWithMultiSelectProps) => {
  return (
    <TextField
      fullWidth
      select
      className={rest.className}
      value={value}
      label={rest.label}
      onChange={(e) => onChange(e as SelectChangeEvent<string[]>)}
      onBlur={rest.onBlur}
      slotProps={{
        select: {
          multiple: true,
          name: rest.name,
          renderValue: (selected) =>
            (selected as string[])
              .map((v) => items.find((i) => i.value === v)?.name)
              .filter(Boolean)
              .join("; "),
        },
      }}
    >
      {items.map((item) => (
        <MenuItem key={item.value} value={item.value}>
          <Checkbox checked={value.includes(item.value)} />
          <ListItemText primary={item.name} />
        </MenuItem>
      ))}
    </TextField>
  );
};

export default DropdownWithMultiSelect;
